import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Landing from './pages/Landing';
import Signup from './pages/Signup';
import Login from './pages/Login';
import ConfirmEmail from './pages/ConfirmEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import CatProfiles from './pages/CatProfiles';
import IngredientChecker from './pages/IngredientChecker';
import BehaviorChat from './pages/BehaviorChat';
import Analytics from './pages/Analytics';
import Affiliates from './pages/Affiliates';
import Subscription from './pages/Subscription';
import Settings from './pages/Settings';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import PricingPage from './pages/PricingPage';
import RefundPolicy from './pages/RefundPolicy';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import Footer from './components/Footer';
import PostHogProvider from './components/PostHogProvider';
import './App.css';

function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=') || location.hash?.includes('access_token=')) {
    return <AuthCallback />;
  }

  const showFooter = !['/login', '/signup', '/confirm-email', '/forgot-password', '/reset-password', '/auth/callback'].includes(location.pathname) && !location.pathname.startsWith('/dashboard') && !location.pathname.startsWith('/cat-profiles') && !location.pathname.startsWith('/ingredient-checker') && !location.pathname.startsWith('/behavior-chat') && !location.pathname.startsWith('/analytics') && !location.pathname.startsWith('/affiliates') && !location.pathname.startsWith('/subscription') && !location.pathname.startsWith('/settings');

  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/confirm-email" element={<ConfirmEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/cat-profiles" element={<ProtectedRoute><CatProfiles /></ProtectedRoute>} />
        <Route path="/ingredient-checker" element={<ProtectedRoute><IngredientChecker /></ProtectedRoute>} />
        <Route path="/behavior-chat" element={<ProtectedRoute><BehaviorChat /></ProtectedRoute>} />
        <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
        <Route path="/affiliates" element={<ProtectedRoute><Affiliates /></ProtectedRoute>} />
        <Route path="/subscription" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {showFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <PostHogProvider>
      <BrowserRouter>
        <div className="App">
          <AppRouter />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </PostHogProvider>
  );
}

export default App;
